export default {
  zh: {
    '首页': '首页',
    '科普': '科普',
    '登录': '登录',
    '注册': '注册',
    '查询': '查询',
    '医学研究所': '中国医学科学院基础医学研究所',
    '基础学院': '北京协和医学院基础学院',
    '共享服务平台': '国家柯基资源共享服务平台',
    '科学数据中心': '国家人口健康科学数据中心',
    '中国人成骨不全症变异数据库（COIMD）':'中国人成骨不全症变异数据库',
    '中国人成骨不全症': '中国人成骨不全症变异数据库（Chinese osteogenesis imperfecta mutation database, COIMD）由已报道的中国人群中OI致病基因变异数据，以及赵秀丽研究室新发现的OI致病变异数据组成，为目前国内单中心OI患者群体最大的数据库。提供致病变异、病例查询及知识科普等服务，并收录新发现致病数据。',
    '免责声明': '免责声明',
    '致病基因查询': '致病基因查询',
    '免责': '本网站上的信息完整、真实、准确或不存在误导性。 本网站上的任何内容，都不应当作为或理解为任何性质的建议。如果您希望得到有关问题的建议，您应咨询相关专业人员。',
    '邮箱': '邮箱',
    '密码': '密码',
    '病例编号': '病例编号',
    '致病基因': '致病基因',
    '致病突变': '致病突变',
    '氨基酸改变': '氨基酸改变',
    '突变类型': '突变类型',
    '突变位置': '突变位置',
    '密码子改变': '密码子改变',
    '参考文献': '参考文献',
    '病例': '病例',
    '注释信息': '注释信息',
    '查看病例': '查看病例',
    '数据来源：中国医学科学院基础医学研究所': '数据来源：中国医学科学院基础医学研究所',
    '联系人: 赵秀丽': '联系人: 赵秀丽',
    '电话': '电话: 010-69156485（工作日9:00-16:00）',
    '邮箱：xiulizhao@ibms.pumc.edu.cn': '邮箱：xiulizhao@ibms.pumc.edu.cn',
    '地址：北京市东单三条5号': '地址：北京市东单三条5号',
    '技术支持：国家人口健康科学数据中心': '技术支持：国家人口健康科学数据中心',
    '电话：010-65250541（工作日8:30-17:00）': '电话：010-65250541（工作日8:30-17:00）',
    '邮箱：rkjkpt@126.com': '邮箱：rkjkpt@126.com'
  },
  en: {
    '首页': 'Home',
    '科普': 'Universal',
    '登录': 'Login',
    '注册': 'Register',
    '查询': 'FIND',
    '医学研究所': 'Institute of Basic Medical Sciences Chinese Academy of Medical Sciences',
    '基础学院': 'School of Basic Medicine Peking Union Medical College',
    '共享服务平台': 'National Science & Technology Infrastructure',
    '科学数据中心': 'National Population Health Data Center',
    '中国人成骨不全症变异数据库（COIMD）':'Chinese Osteogenesis Imperfecta Mutation Database',
    '中国人成骨不全症': 'The Chinese osteogenesis imperfecta mutation database (COIMD) is based on the collation of the reported OI pathogenic variation data in Chinese population and some novel variants provided by Institute of Basic Medicine, Chinese Academy of Medical Sciences (IBMS, CAMS). It is currently the largest database of single-center OI patient groups in China. You can get the information of pathogenic variation, disease cases, popular science knowledge and newly discovered pathogenic data from COIMD.',
    '免责声明': 'Disclaimer',
    '致病基因查询': 'Search',
    '免责': 'Please note that this up-to-date public version of our database is freely available only to registered users from academic institutions/non-profit organizations. All commercial users are required to get a license from us. You should not copy, store or re-distribute COIMD data without permission . Copyright © Institute of Basic Medical Sciences Chinese Academy of Medical Sciences & School of Basic Medicine Peking Union Medical College . All rights reserved.',
    '邮箱': 'E-mail',
    '密码': 'password',
    '病例编号': 'case number',
    '致病基因': 'pathogenic gene',
    '致病突变': 'pathogenic mutations',
    '氨基酸改变': 'amino acid change',
    '突变类型': 'type of mutation',
    '突变位置': 'mutation position',
    '密码子改变': 'codon change',
    '参考文献': 'reference',
    '病例': 'medical record',
    '注释信息': 'annotation information',
    '查看病例': 'Detail',
    '数据来源：中国医学科学院基础医学研究所': 'Data Source：Institute of Basic Medical Sciences, Chinese Academy of Medical Sciences',
    '联系人: 赵秀丽': 'Contacts: Xiuli Zhao',
    '电话': 'Telephone: 010-69156485(weekdays: 9:00 -16:00)',
    '邮箱：xiulizhao@ibms.pumc.edu.cn': 'Email: xiulizhao@ibms.pumc.edu.cn',
    '地址：北京市东单三条5号': 'Address: 5 Dongdan Santiao, Beijing, China',
    '技术支持：国家人口健康科学数据中心': 'Technical support: National Population Health Data Center',
    '电话：010-65250541（工作日8:30-17:00）': 'Telephone: 010-65250541(weekdays: 9:00 -16:00)',
    '邮箱：rkjkpt@126.com': 'Email: rkjkpt@126.com'
  }
}
